import React from 'react'
import { Form } from 'semantic-ui-react'
import { CheckClimaEl } from '../../../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import InfoPopup from '~/components/InfoPopup'
import TableLandUse from './TableLandUse'
import { ClimateCheckSelectType } from '~/api/services/climaCheck'

interface Props {
  landTypes: ClimateCheckSelectType[]
}

const FifthteenStep:React.FC<Props> = ({ landTypes }) => {
  const{ control } = useFormContext()

  const fieldNames = [
    'silageMaizeArea',
    'organicSoilSilageMaizeArea',
    'permanentGrasslandArea',
    'organicSoilPermanentGrasslandArea',
    'arableGrassArea',
    'organicSoilArableGrassArea'
  ]

  const [
    watchMaiseCultivation,
    watchMaiseOrganicSoile,
    watchGrassLandAre,
    watchGrassOrganicSoile,
    watchGrassArea,
    watchGrassOrganicSoil
  ] = useWatch({ control, name: fieldNames })

  function renderLandUse() {
    return <div style={{ marginBottom: '2em' }}>
      <div style={{ width: 'fit-content' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 3 }}>
          <div>{'Landnutzung'}</div>
          <InfoPopup
            content={'Bitte geben sie hier ausschließlich die Flächen an, auf denen Sie Futter für ihre Milchkühe und ihre weibliche Nachzucht produziert haben.'}
            styleIcon={{ fontSize: '1.2em' }}
            position={'top center'}
          />
        </div>
        <CheckClimaEl.StyledDivider />
      </div>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name={'silageMaizeArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Anbaufläche Silomais'}</label>
          </div>}
          rules={{
            required: Boolean(watchMaiseOrganicSoile),
            min: watchMaiseOrganicSoile ?? 0
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
        <FormFields.Input
          control={control}
          name={'organicSoilSilageMaizeArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Silomais auf org. Boden'}</label>
          </div>}
          rules={{
            required: Boolean(watchMaiseCultivation),
            max: watchMaiseCultivation ?? null
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
      </Form.Group>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name={'permanentGrasslandArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Anbaufläche Dauergrünland'}</label>
          </div>}
          rules={{
            required: Boolean(watchGrassOrganicSoile),
            min: watchGrassOrganicSoile ?? 0
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
        <FormFields.Input
          control={control}
          name={'organicSoilPermanentGrasslandArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Dauergrünland auf org. Boden'}</label>
          </div>}
          rules={{
            required: Boolean(watchGrassLandAre),
            max: watchGrassLandAre ?? null
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
      </Form.Group>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name={'arableGrassArea'}
          suffix={' ha'}
          rules={{
            required: Boolean(watchGrassOrganicSoil),
            min: watchGrassOrganicSoil ?? 0
          }}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Anbaufläche Ackergras'}</label>
          </div>}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
        <FormFields.Input
          control={control}
          name={'organicSoilArableGrassArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Ackergras auf org. Boden'}</label>
          </div>}
          rules={{
            required: Boolean(watchGrassArea),
            max: watchGrassArea ?? null
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
      </Form.Group>
    </div>
  }

  function renderLandUseChange() {
    return <div>
      <div style={{ width: 'fit-content' }}>
        <div style={{ display: 'flex', gap: 5 }}>
          {'Landnutzungsänderung'}
        </div>
        <CheckClimaEl.StyledDivider />
      </div>
      <TableLandUse
        landTypes={landTypes}
      />
    </div>
  }

  return <div>
    {renderLandUse()}
    {renderLandUseChange()}
  </div>
}
export default FifthteenStep